module.exports = __webpack_public_path__ + "img/repair_bg_repair@2x.png";